import tag from 'src/internal/shared/graphql/tag';

/**
 * @see https://trailhead.corp.stripe.com/docs/sail-data/api/gql
 */
export default tag;
